export default __webpack_public_path__ + "static/telenorLogo-58c7db49bfd6882e81f5e81afdee5428.png";